import { createCalendar } from "@internationalized/date";
import { nanoid } from "nanoid";
import { useRef, useState } from "react";
import {
	type AriaDatePickerProps,
	type DateValue,
	useDateField,
	useLocale,
} from "react-aria";
import { useDateFieldState } from "react-stately";
import { cn } from "@/lib/utils";
import { DateSegment } from "./DateSegment";

function DateField(props: AriaDatePickerProps<DateValue>) {
	const ref = useRef<HTMLDivElement | null>(null);

	const { locale } = useLocale();
	const state = useDateFieldState({
		...props,
		locale,
		createCalendar,
	});
	const { fieldProps } = useDateField(props, state, ref);

	const [segmentIds] = useState(() => state.segments.map(() => nanoid()));

	return (
		<div
			{...fieldProps}
			ref={ref}
			className={cn(
				`inline-flex flex-1 h-[18px] items-center justify-end rounded-l-md
        		 bg-transparent py-2 px-1.5 text-sm`,
				props.isDisabled ? "cursor-not-allowed opacity-50" : "",
			)}
		>
			{state.segments.map((segment, i) => (
				<DateSegment key={segmentIds[i]} segment={segment} state={state} />
			))}
			{state.isInvalid && <span aria-hidden="true">🚫</span>}
		</div>
	);
}

export { DateField };
